import React, { Component } from 'react';

import api from '../../../api/api';

import Modal from "./Modal"

import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable"


class Caja extends Component {
    constructor() {
        super();
    }

    getFirmaLink = (data) => {
        let componenteLink = <p className="ui-inline-message">Sin imagen</p>;
        
        if (data && data.imagen){
            const linkImagen = api.BASE_URL + data.imagen;
            componenteLink = (
                <div>
                    <a className="ui-table-link" href={linkImagen} target="_blank" rel="noopener noreferrer">
                        Imagen
                    </a>
                </div>
            );
        }

        return componenteLink
    }

    render() {
        const columns = [
            {
                Header: "id",
                id: "id",
                accessor: "id",
                show: false,
                private: true,
            },
            {
                Header: "Firma",
                id: "imagen",
                accessor: d => this.getFirmaLink(d),
                show: true,
            },
            {
                Header: "sucursal",
                id: "sucursal",
                accessor: d => d.sucursal ? d.sucursal.nombre : '',
                show: true,
            },
        ]

        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'recibos_firmas_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'recibos_firmas_edit',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'recibos_firmas_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'recibos_firmas_delete',
                    }
                ]}
                apiUrl={api.recibos.firmas}
                columns={columns}
                // exportUrl={api.recibos.firmas}
                title={"Firmas de Recibo según Sucursal"}
            />
        );
    }
}

export default Caja;



// WEBPACK FOOTER //
// ./src/views/Recibos/Firmas/Firmas.js